import type { FC, HTMLAttributes } from "react";

import classnames from "classnames";

import { useDrawer } from "../providers";

import styles from "../Drawer.module.scss";

type DrawerBodyProps = HTMLAttributes<HTMLDivElement> & {
  isPaddingDisabled?: boolean;
};

export const DrawerBody: FC<DrawerBodyProps> = ({ children, isPaddingDisabled, ...restProps }) => {
  const { isOpen } = useDrawer();

  return (
    <div
      className={classnames(styles.drawerBody, {
        [styles.isOpen]: isOpen,
        [styles.paddingDisabled]: isPaddingDisabled, // Might be removed if DSv3 styles cover it.
      })}
      data-testid="drawer-body"
      {...restProps}
    >
      {children}
    </div>
  );
};

DrawerBody.displayName = "DrawerBody";
